const Ellipsis = () => (
  <li className='page-item'>
    <span className='page-link'>…</span>
  </li>
);

export default Ellipsis;
